import {
  cssPropertyToDefaultValueMap,
  generateSkinDefaults,
} from '@wix/editor-elements-panel';

import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

export const textOnPathSkin = {
  'path-stroke': {
    type: 'CSS_COLOR',
    defaultValue: '#000000',
    state: 'regular',
    paramName: 'path-stroke',
  },
  'alpha-path-stroke': {
    type: 'ALPHA',
    state: 'regular',
    defaultValue: '1',
    paramName: 'alpha-path-stroke',
  },
  'letter-spacing': {
    type: 'SIZE',
    defaultValue: '0em',
    state: 'regular',
    paramName: 'letter-spacing',
  },
  'line-height': {
    type: 'SIZE',
    defaultValue: 'unset',
    state: 'regular',
  },
  'text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: cssPropertyToDefaultValueMap['text-transform'],
    state: 'regular',
  },
  font: {
    type: 'FONT',
    state: 'regular',
    defaultValue: 'font_8',
  },
  'text-fill': {
    type: 'CSS_COLOR',
    state: 'regular',
    defaultValue: '#000000',
  },
  'dominant-baseline': {
    type: 'CSSString',
    state: 'regular',
    defaultValue: 'middle',
  },
  'stroke-linecap': {
    type: 'CSSString',
    state: 'regular',
    defaultValue: 'round',
  },
  'stroke-linejoin': {
    type: 'CSSString',
    state: 'regular',
    defaultValue: 'round',
  },
} as const satisfies SkinDefinition;

export const textOnPathSkinDefinitionMap: Record<string, SkinDefinition> = {
  'wixui.skins.TextOnPath': textOnPathSkin,
};

export default generateSkinDefaults(textOnPathSkinDefinitionMap);
